import React from 'react'

const Button = ({
  label,
  bgColor,
  icon,
  width,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  disabled = false,
  loading = false,
  iconPosition = 'right'
}) => {
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    accent: 'btn-accent',
    danger: 'btn-danger',
    ghost: 'btn-ghost',
    // Legacy support for old bgColor prop
    wayrideBgColor: 'btn-primary',
  };

  const sizes = {
    small: 'px-3 py-2 text-xs',
    default: 'px-5 py-3 text-sm',
    large: 'px-6 py-3.5 text-base',
  };

  // If legacy bgColor is passed, use it for backward compatibility
  const variantClass = bgColor
    ? variants[bgColor] || 'btn-primary'
    : variants[variant];

  const sizeClass = sizes[size];
  const widthClass = fullWidth ? 'w-full' : width || '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${variantClass}
        ${sizeClass}
        ${widthClass}
        inline-flex items-center justify-center gap-2 rounded-xl font-semibold
        transition-all duration-200 ease-out
        focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none
        ${!disabled && !loading ? 'hover:-translate-y-0.5 active:translate-y-0' : ''}
      `}
    >
      {loading ? (
        <>
          <svg className="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>Loading...</span>
        </>
      ) : (
        <>
          {icon && iconPosition === 'left' && <span className="flex-shrink-0">{icon}</span>}
          <span>{label}</span>
          {icon && iconPosition === 'right' && <span className="flex-shrink-0">{icon}</span>}
        </>
      )}
    </button>
  )
}

export default Button
